exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orderWrapper {\n  position: fixed;\n  top:0;\n  left:0;\n  right:0;\n  bottom:0;\n  z-index:1110;\n  background-color:#5cb85c;\n  color:white;\n  overflow-y: scroll;\n}\nform {\n  margin-top:100px;\n}\n.hideAddBtn {\n  position: fixed;\n  right:5px;\n  top:5px;\n  z-index: 1110;\n}\n.card {\n  margin-bottom:10px;\n}\n.header {\n  position: fixed;\n  top:0;\n  padding-top:20px;\n  width:100%;\n  left:0;\n  z-index: 1109;\n  background-color:#5cb85c;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/order.component.css
// module id = 437
// module chunks = 0